import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import Heading from 'components/v2/Heading'
import { ReactElement } from 'react'

const Container = styled.div`
  padding: 30px 20px;
`

export const LoyaltyHeader = (): ReactElement => {
  return (
    <Container>
      <Heading.H3>
        <FormattedMessage id="spanish.snacks.header.label" defaultMessage="Loyalty Campaigns" />
      </Heading.H3>
    </Container>
  )
}
